import PropTypes from 'prop-types'
import { memo, useEffect } from 'react'
import SelectBox from 'components/form/SelectBox'
import {
  reset,
  setCategoryByFullPath,
  setSelectedCategory,
  setSelectedCategoryDetail,
} from 'features/channel/add/channelAddSlice'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import Table from 'components/table/Table'
import ErrorText from 'components/form/ErrorText'
import fetchBizCategories from 'features/channel/add/thunk/fetchBizCategories'
import { isEmpty, isEmptyObject } from 'utils'

const Category = memo(
  ({ selectedCategoryError, selectedCategoryDetailError, isEditable }) => {
    const {
      bizCategories,
      isCategoryLoading,
      selectedCategory,
      selectedCategoryDetail,
      oldCategoryFullPath,
    } = useSelector(state => state.channel.channelAdd, shallowEqual)

    const dispatch = useDispatch()

    useEffect(() => {
      dispatch(fetchBizCategories())
      return () => dispatch(reset())
    }, [dispatch])

    useEffect(() => {
      dispatch(setCategoryByFullPath())
    }, [dispatch, oldCategoryFullPath, bizCategories])

    const onSelectBusiness = v => dispatch(setSelectedCategory(v))
    const onSelectBusinessDetails = v => dispatch(setSelectedCategoryDetail(v))

    return (
      <Table.Row
        className="tr_category"
        error={selectedCategoryError || selectedCategoryDetailError}>
        <th scope="row">
          <div className="inner_tbl">업종선택</div>
        </th>
        <td>
          <div className="inner_tbl">
            <div className="group_select">
              <SelectBox
                placeholder="업종"
                value={selectedCategory}
                focusOnError
                error={selectedCategoryError}
                onValueChange={onSelectBusiness}
                disabled={isCategoryLoading || !isEditable}
                noBlurOnDefault={!isEmpty(selectedCategory?.children)}>
                {bizCategories.map(category => (
                  <SelectBox.Item key={category.name} value={category}>
                    {category.name}
                  </SelectBox.Item>
                ))}
              </SelectBox>

              <SelectBox
                placeholder="세부업종"
                value={selectedCategoryDetail}
                focusOnError
                error={selectedCategoryDetailError}
                onValueChange={onSelectBusinessDetails}
                disabled={isEmpty(selectedCategory.children) || !isEditable}
                noBlurOnDefault={
                  selectedCategoryDetail &&
                  !isEmptyObject(selectedCategoryDetail)
                }>
                {selectedCategory.children.map(businessDetail => (
                  <SelectBox.Item
                    key={businessDetail.name}
                    value={businessDetail}>
                    {businessDetail.name}
                  </SelectBox.Item>
                ))}
              </SelectBox>
              <ErrorText
                tag="p"
                error={selectedCategoryError || selectedCategoryDetailError}
              />
            </div>
          </div>
        </td>
      </Table.Row>
    )
  }
)

export default Category
Category.displayName = 'Category'
Category.propTypes = {
  selectedCategoryDetailError: PropTypes.string,
  selectedCategoryError: PropTypes.string,
  isEditable: PropTypes.bool,
}
